import { MessageCircle, Mail, Instagram } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function Contact() {
  const { settings, whatsappLink } = useSettings();
  return (
    <main className="page" data-testid="contact-page">
      <div className="page-head">
        <span className="eyebrow">Say hello</span>
        <h1>
          Reach the <em>studio.</em>
        </h1>
        <p>For enquiries, styling appointments and customization, speak with us directly. We reply within one business day.</p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 20, maxWidth: 1000 }}>
        <a href={whatsappLink("Hi Lalita Soujanya, I'd like to enquire.")} target="_blank" rel="noreferrer" className="text-link" style={{ padding: 36, border: "1px solid var(--line)", display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-start" }} data-testid="contact-whatsapp">
          <MessageCircle size={22} style={{ color: "var(--wine)" }} />
          <span className="eyebrow">WhatsApp</span>
          <strong style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 400 }}>{settings.whatsapp_number}</strong>
        </a>
        <a href={`mailto:${settings.email}`} className="text-link" style={{ padding: 36, border: "1px solid var(--line)", display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-start" }} data-testid="contact-email">
          <Mail size={22} style={{ color: "var(--wine)" }} />
          <span className="eyebrow">Email</span>
          <strong style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 400 }}>{settings.email}</strong>
        </a>
        <a href={`https://instagram.com/${settings.instagram_handle}`} target="_blank" rel="noreferrer" className="text-link" style={{ padding: 36, border: "1px solid var(--line)", display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-start" }} data-testid="contact-instagram">
          <Instagram size={22} style={{ color: "var(--wine)" }} />
          <span className="eyebrow">Instagram</span>
          <strong style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 400 }}>@{settings.instagram_handle}</strong>
        </a>
      </div>
    </main>
  );
}
